import {
  Circle,
  Code,
  Javascript,
  Html5,
  Css3,
  Terminal,
  Goal,
  Dog,
  CodeXml,
} from "lucide-react"; // optional - you can replace with react-icons if you prefer
import { motion } from "framer-motion";
export default function CardAnim3({id,data,settings}) {
    const floatIcons = [
  { id: "js", Icon: Circle, angle: -40, speed: 9, direction: 1, label: "JS",color:"rgba(34, 35, 36, 0.93)" },
  { id: "html", Icon: Goal, angle: 20, speed: 13, direction: -1, label: "HTML" ,color:"rgba(34, 35, 36, 0.93)"},
  { id: "css", Icon: Dog, angle: 120, speed: 11, direction: 1, label: "CSS" ,color:"rgba(34, 35, 36, 0.93)"},
  { id: "php", Icon: CodeXml, angle: 200, speed: 15, direction: -1, label: "DEV",color:"rgba(34, 35, 36, 0.93)" },
 
];
  return (<>
  <div className="cardCA3Outer">
            <div className="cardCA3-glow"></div>
            {floatIcons.map((cfg, i) => {
                const { Icon, angle, speed, direction, id, label,color } = cfg;
                // Using CSS transform for initial placement, framer-motion to rotate around center
                return (
                  <motion.div
                    key={id}
                    className={`shapeCA3-no circleCA3${i+1}`}
                    // style={{ ["--angle" as any]: `${angle}deg` }}
                    animate={{ rotate: direction === 1 ? 360 : -360 }}
                    transition={{
                      repeat: Infinity,
                      ease: "linear",
                      duration: speed,
                      delay: i * 0.15,
                    }}
                    aria-hidden
                    title={label}
                  >
                    <div className=""> <div className={`cardCA3-badgeCA3 badgeCA3-${i%2==0?"a":"b"}`}  >
                <div className="iconCA3"><Icon size={28} color={color} /></div>
                <div  >
                  <div style={{fontSize:"20px",fontWeight:"bold"}}>28k</div>
                  <div style={{fontSize:"13px",fontWeight:"500"}}>Total Students</div>
                </div>
              </div></div>
                  </motion.div>
                );
              })}
   
            {/* Tilting image */}
            <div className="cardCA3-img-box tiltCA3">
              <img src={data?.imgSrc} alt="teacher" />

       
            </div>
          </div>  
            <style>{`
            .cardCA3Outer{position:relative;max-width:380px;}
        .circleCA31, .circleCA32 ,.circleCA33, .circleCA34  {
  width: 120px;
  height: 120px;
  
  
}
.circleCA31 { left: 130px; top: 240px;animation: slideCA3RH1 6s linear infinite;}
.circleCA32 { right: 130px; bottom: 140px;animation: slideCA3RH1 3s linear infinite;}
.circleCA33 { left: 40px; top:-60px;animation: slideCA3UpH1 2s linear infinite;}
.circleCA34 { right: -20px; bottom: -40px;animation: slideCA3UpH1 5s linear infinite;}

.waveCA3-bg {
  position: absolute;
  width: 100%;
  height: 400px;
  bottom: 0;
  left: 0;
;
  background-size: cover;
  opacity: 0.15;
  animation: waveCA3Move 12s linear infinite;
}    
/* GLOW */
.cardCA3-glow {
  position: absolute;
  width: 390px;
  height: 390px;
  background: radial-gradient(circleCA3, #3da7ff55, transparent 70%);
  filter: blur(40px);
  z-index: 0;
  top: 20px;
  right: 0;
  animation: glowPulseCA3 5s ease-in-out infinite;
}

.cardCA3-img-box {
  position: relative;
  width: 340px;
  height: 420px;
}

.cardCA3-img-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 34px;
  box-shadow: 0 20px 60px rgba(0,0,0,.25);
}
  /* BACKGROUND SHAPES */
.shapeCA3 { 
  position: absolute;
  opacity: 0.32;
}.shapeCA3-no {width: 240px;
  position: absolute;
  opacity: 1;z-index:99;
}

/* BADGES */
.cardCA3-badgeCA3 {
  position: absolute;
  background: rgba(173, 213, 225, 1);
  border-radius: 20px;
  padding: 12px 20px;
  display: flex;
  gap: 10px;
  align-items: center;
  color: #000;
  box-shadow: 0 12px 30px rgba(0,0,0,0.15);
}
.cardCA3-badgeCA3 .iconCA3 {
  width: 64px;position:relative;top:-30px;
  height: 64px;display:flex;justify-content:center;align-items:center;
  background: #e8f1ff;
  border-radius: 50%; border-bottom-right-radius: 5%;
}
.badgeCA3-a {
  top: 40px;
  right: -80px;
}
.badgeCA3-b {
  bottom: -30px;
  left: -20px;
}

/* ANIMATIONS */
@keyframes floatCA3 {
  0% { transform: translateY(0px);}
  50% { transform: translateY(-14px);}
  100% { transform: translateY(0px);}
}

@keyframes glowPulseCA3 {
  0% { opacity:.6; transform: scale(1); }
  100% { opacity: 1; transform: scale(1.1); }
}

@keyframes spinCA3 { to { transform: rotate(360deg);} }

@keyframes waveCA3Move {
  0% { background-position-x: 0px;}
  100% { background-position-x: 1000px;}
}

.fadeInUp { opacity:0; animation: fadeUpCA3 .8s ease forwards; }
@keyframes fadeUpCA3 {
  0% {opacity:0; transform: translateY(20px);}
  100% {opacity:1; transform: translateY(0);}
}

.slideCA3InRight { opacity:0; animation: glowPulseCA3 10s linear infinite;; }
@keyframes slideCA3RH1 {
  0% {opacity:1; transform: translateY(0px);}
  50% {opacity:1; transform: translateY(-40px);}
  100% {opacity:1; transform: translateY(0px);}
}

.slideCA3InUp { opacity:0; animation: slideCA3UpH1 .6s ease forwards .35s; }
@keyframes slideCA3UpH1 {
  0% {opacity:1; transform: translateX(0px);}
  50% {opacity:1; transform: translateX(-20px);}
  100% {opacity:1; transform: translateX(0px);}
}

/* TILT */
.tiltCA3:hover {
  transform: rotate3d(1,1,0,8deg);
  transition: .35s;
}

/* RESPONSIVE */
@media (max-width: 900px) {
  .cardCA3-container { grid-template-columns: 1fr; text-align:center; }
  .cardCA3-desc { width:100%; }
  .cardCA3-img-box { margin-top:40px; }
}

`}</style>
 </> );
}
